import "core-js/es6/array";
import "core-js/es6/map";
import "core-js/es6/object";
import "core-js/es6/promise";
import "core-js/es6/set";
import "core-js/es6/string";
import "core-js/es7/array";
import "core-js/es7/object";
import "raf/polyfill";

import { render } from "react-dom";
import { Provider } from "react-redux";

import App from "./App";

import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { catchExceptionCallback } from "resbutler-ui/error";
import { reduxStore } from "./store/store";

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => catchExceptionCallback(error),
  }),
});

render(
  <Provider store={reduxStore}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Provider>,
  document.getElementById("app") as HTMLElement
);
